import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 35 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "m34.302 5.063-2.79 5.163a.56.56 0 0 0-.063.354l1.016 7.595a.96.96 0 0 1-.406.92l-5.78 4.039a.6.6 0 0 0-.201.245l-2.84 6.573c-.16.369-.497.63-.895.689l-4.895.714a1.5 1.5 0 0 1-.447 0l-4.895-.714a1.17 1.17 0 0 1-.897-.688L8.37 23.38a.56.56 0 0 0-.2-.246L2.39 19.098a.96.96 0 0 1-.406-.92L3 10.584a.6.6 0 0 0-.063-.353L.139 5.063a1.2 1.2 0 0 1-.137-.621L.135 2.18c.027-.416.268-.785.644-.97L2.37.42a1.45 1.45 0 0 1 1.414.07l3.574 2.237a.58.58 0 0 0 .477.063L16.77.067a1.55 1.55 0 0 1 .9 0l8.935 2.723a.58.58 0 0 0 .476-.063L30.657.49A1.45 1.45 0 0 1 32.07.42l1.589.788c.372.186.617.555.643.97l.134 2.263c.01.216-.033.43-.138.62z"
    }, null, -1)
  ]))]))
}
export default { render: render }